import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const initialState = {
  product: '',
  outerbox: '',
};

const store = (set, get) => ({
  ...initialState,

  setUserId: (page, value) => {
    set((prev) => ({ ...prev, [page]: value }));
  },

  getUserId: (page) => {
    const pageUser = get()[page];
    if (pageUser !== undefined && pageUser !== '') {
      return pageUser;
    }
    return '';
  },
  reset: () => {
    set(initialState);
  },
});

const userStore = create(
  persist(store, {
    name: 'user',
    storage: createJSONStorage(() => localStorage),
  }),
);

export default userStore;
